const claimModel = {
  clty:{
    type:"select",
    title: "What was the claim/accident for?",
    validators: ["required"],
    options: [{value:"Liability",name:"Liability"},{value:"Collision",name:"Collision"},{value:"Liability &amp; Collision",name:"Liability &amp; Collision"},{value:"Other non-responsible Comp/SP",name:"Other non-responsible Comp/SP"},{value:"Non-responsible Accident Ben.",name:"Non-responsible Accident Ben."},{value:"Non-resp Direct Compensation",name:"Non-resp Direct Compensation"},{value:"Non-responsible Collision",name:"Non-responsible Collision"},{value:"Hail",name:"Hail"},{value:"Vandalism",name:"Vandalism"},{value:"Fire",name:"Fire"},{value:"Theft",name:"Theft"},{value:"Glass Breakage",name:"Glass Breakage"},{value:"Glass Repair",name:"Glass Repair"},{value:"Theft - Entire Vehicle",name:"Theft - Entire Vehicle"}],
    value:"Non-responsible Accident Ben."
  },
  cldt:{
    type:"date",
    validators: ["required"],
    title: "Claim/Accident date",
    value:"20210101"
  }
}  

export default claimModel;